<template>
    <div class="custom-form">
        <div class="form-toolbar">
            <el-tabs v-model="activeName" stretch>
                <!-- 表单字段 -->
                <el-tab-pane label="字段" name="components" style="margin-top:-3%">
                    <draggable :list="list1" :options="formToolbarOpts">
                        <transition-group name="list-complete">
                            <div style="float:left;width:40%;" v-for="element in list1" :key="element.id" class="list-complete-item">
                                {{ element.label }}
                            </div>
                        </transition-group>
                    </draggable>
                </el-tab-pane>
                <!-- 表单字段属性编辑 -->
                <el-tab-pane label="属性" name="props" lazy>
                    <FieldProps :key="loadTimer" v-if="selectedField" :field="selectedField" :modelData="modelData" :channelFlag="channelFlag" :appId="appId" :fieldsList="fieldsList" :relateModelList="modelData.relateModelList" @renderValue="renderValue" @renderModelData="renderModelData" @changeSelectTableHeaderFields="changeSelectTableHeaderFields" @renderFieldList="renderFieldList"/>
                    <div v-else>还没有选择字段</div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <div class="form-content">
            <div class="modelIntroduce">
                <el-popover
                    placement="bottom-start"
                    title="添加字段步骤："
                    width="185"
                    trigger="hover"
                    content="从左侧的字段列表选择字段，点击后按住鼠标拖拽到右边界面，待出现浅色背景区域时松开鼠标完成设置。">
                    <el-button slot="reference">使用说明</el-button>
                </el-popover>
                <el-radio-group v-model="modelData.colSpan">
                    <el-radio  :label="1">一列</el-radio>
                    <el-radio  :label="2">两列</el-radio>
                    <el-radio  :label="3">三列</el-radio>
                    <!-- <el-radio  :label="4">四列</el-radio> -->
                </el-radio-group>
                 <!-- 扩展字段2 用来做 表单级联显示模式 默认为0 级联显示  1不级联显示-->
                 <el-tooltip v-if="showCascadeMode" effect="light" content="是否使用表单级联功能，将所有关联表单的数据都级联带出显示" placement="top">
                    <el-checkbox  style="margin-left: 30px"  class="checkBox-style" v-model="cascadeModeConfig"><el-tag size="mini">多层级联</el-tag></el-checkbox>
                </el-tooltip>
                <el-tooltip effect="light" content="关联显示配置：是否使用主子表级联功能，使用的话录入数据时可以将配置的子表带出，同步录入数据" placement="top">
                    <el-button style="margin-left: 50px" type="primary" icon="el-icon-connection" title="关联显示配置" @click="configRelateModelConfig" round></el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="数据卡片页展示配置：数据卡片页展示，可以展示出当前数据的关联数据以及当前数据被引用的数据" placement="top">
                    <el-button  type="primary" icon="el-icon-s-operation" title="数据展示配置" @click="configShowCardModelConfig" round></el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="左树右表配置：可以选择下拉、选项(单选)、数据字典、业务分类、关联数据等类型字段用作表单列表左树显示配置" placement="top">
                    <el-button type="info" icon="el-icon-notebook-2" title="左树右表配置" @click="configFormLeftTree" round></el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="默认表单列表字段显示配置：可以选择表单列表显示的字段，对所有系统用户生效" placement="top">
                   <el-button type="warning" icon="el-icon-view" title="表单列表字段显示配置" @click="handleFilterField" round></el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="默认表单查询字段显示配置：可以选择表单列表默认显示查询的字段" placement="top">
                  <el-button  icon="el-icon-search" title="表单查询字段显示配置" @click="handleFilterCondition" round></el-button>
                </el-tooltip>
                <el-popover
                    v-if="isViewSubFormBtn"
                    style="margin-left:30px"
                    placement="bottom-start"
                    title="子表单显示模式："
                    width="185"
                    trigger="hover"
                    content="当前表单使用了子表单字段，则可以设置子表单显示模式为纵向显示还是横向显示，默认是纵向显示。">
                    <el-button slot="reference">子表单模式</el-button>
                </el-popover>
                 <el-radio-group v-if="isViewSubFormBtn" v-model="modelData.ext1"><!-- 扩展字段ext1用来做 子表单显示模式 0为默认 纵向显示  1为横向标签显示-->
                    <el-radio  :label="0">纵向显示</el-radio>
                    <el-radio  :label="1">横向显示</el-radio>
                </el-radio-group>
            </div>
            <draggable :list="fieldsList" :options="formContentOpts" class="field-list" @change="handleFormChange">
                <transition-group name="form">
                    <!-- class="form-item" -->

                    <div class="form-item"
                        v-for="(element, index) in fields"
                        :key="element.id"
                        :style="activeStyle(element)"
                        :class="activeClass(element.id)"
                        @click="handleSelectItem(element)">
                        <label class="ellipsis form-item-label ">
                            <i class="form-required">
                                <span v-if="element.hasOwnProperty('options') && element.options.required">*</span>
                                <span v-else>&nbsp;&nbsp;</span>
                            </i>
                            {{ element.name }}
                        </label>
                        <!-- 子表单 -->
                        <SubformField
                            v-if="element.type === 'subform'"
                            key='formField'
                            :fieldList='element.options.fieldList'
                            @itemSelect="handleSubformItemSelect"
                        />
                        <div class="form-item-value" v-else key='formField'>{{ element.hasOwnProperty('options') ? element.options.defaultValue:'' }}</div>
                        <div class="form-item-option" v-if="fields.length > 1&&isCanDelete(element)">
                            <i class="el-icon-delete" @click.stop="handleDeleteItem(index)" title="删除"></i>
                        </div>
                    </div>
                </transition-group>
            </draggable>
            <el-dialog
              title="关联显示配置"
              :visible.sync="isConfigRelateModelConfig"
              width="60%"
              >
                <el-tooltip v-if="showRelateModelCf" effect="light" content="配置使用态下显示关联了当前表单的其他表单数据" placement="top">
                   <el-checkbox  class="checkBox-style" v-model="relateModelConfig"><el-tag size="mini">启用关联显示</el-tag></el-checkbox>
                </el-tooltip>
                <el-form v-if="relateModelConfig" class="relateModel">
                    <el-form-item label="关联表单"> 
                        <el-tooltip effect="light" content="关联过当前表单的所有其他表单，选择后，在当前表单的使用态下展示出来。可以拖拽设置显示顺序" placement="top">
                            <el-checkbox-group v-model="relateModelSelected"  @change="handleRelateModelCheckedChange">
                              <draggable :list="modelData.relateModelList" :options="relateFormOpts"  @change="handleRelateFormChange">
                                <el-checkbox v-for="obj in modelData.relateModelList"  :key="obj.id" :label="obj.id" >{{obj.modelName}}</el-checkbox>
                              </draggable>  
                            </el-checkbox-group> 
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item label="关联表单属性">
                        <el-checkbox v-model="modelData.relateModelRequired" label="必填" name="type"></el-checkbox>
                        <el-checkbox v-model="modelData.relateModelQuote" label="引用数据" name="type"></el-checkbox>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <el-dialog
              title="卡片模式显示配置"
              :visible.sync="isConfigShowCardModelConfig"
              width="60%"
              >
                <el-tooltip v-if="showRelateModelCf" effect="light" content="配置使用态下显示关联了当前表单的其他表单数据" placement="top">
                    <el-checkbox  class="checkBox-style" v-model="relateShowCardModelConfig" @change="changeRelateShowCardModelConfig"><el-tag size="mini">启用卡片模式显示</el-tag></el-checkbox>
                </el-tooltip>
                <el-form  class="relateModel" v-if="refFormField">
                    <el-form-item label="当前表单关联数据" >
                        <el-tooltip effect="light" content="关联过当前表单的所有其他表单，选择后，在当前表单的使用态下展示出来。" placement="top">
                            <el-checkbox-group v-model="relateFormFieldModelSelected"  @change="handleConfigShowCardModelData">
                                <el-checkbox v-for="obj in relateShowCardModelFormField"  :key="obj.id" :label="obj.id" >{{obj.name}}</el-checkbox>
                            </el-checkbox-group> 
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item label="被引用的关联数据">
                        <el-checkbox-group v-model="relateLinkFormModelSelected"  @change="handleConfigShowCardModelData">
                           <el-checkbox v-for="obj in modelData.relateModelList"  :key="obj.id" :label="obj.id" >{{obj.modelName}}</el-checkbox>
                        </el-checkbox-group> 
                    </el-form-item>
                </el-form>
            </el-dialog>
            <el-dialog
              title="左树右表配置"
              :visible.sync="isConfigFormLeftTree"
              width="60%"
              >
              <el-form class="relateModel">
                  <el-form-item label="关联表单">
                      <el-tooltip effect="light" content="关联过当前表单的所有其他表单，选择后，在当前表单的使用态下展示出来。" placement="top">
                        <el-checkbox-group v-model="formleftTreeFieldsSelected"  @change="handleFormLeftTreeCheckedChange">
                          <draggable :list="leftTreeFieldsConfigList" :options="leftTreeOpts"  @change="handleDragLeftTree()">
                              <el-checkbox v-for="obj in leftTreeFieldsConfigList"  :key="obj.id" :label="obj.id" >{{obj.name}}</el-checkbox>
                          </draggable>
                        </el-checkbox-group> 
                      </el-tooltip>
                  </el-form-item>
                  <!-- <el-form-item label="关联数据表单字段">
                    <el-input style="width:200px"  maxlength="100" v-model.trim="modelData.linkName" placeholder=""/>
                </el-form-item> -->
              </el-form>
            </el-dialog>
            <el-dialog
              title="选择显示的字段"
              append-to-body
              top="4vh"
              v-if="isShowFilterField"
              :visible.sync="isShowFilterField">
              <!-- <SelectMultiple  ref="selectMultiple" :sourceOptions="sourceOptions"  :allFields="allFields"  :key="fieldTime"  :viewMode="'1'" v-if="isShowFilterField"/> -->
              <SelectMultiple  ref="selectMultiple" :sourceOptions="sourceOptions" :selectViewFields="selectViewFields" :allFields="allFields" :key="fieldTime"  :viewMode="'1'" v-if="isShowFilterField"/>
                <span slot="footer" class="dialog-footer">
                    <el-tooltip content="点击清空后，列表清除当前已选的字段。" effect="light" placement="top">
                    <el-button @click="clearViewField">清空</el-button>
                  </el-tooltip>
                  <el-tooltip content="点击全选，列表会选择当前列表所有字段。" effect="light" placement="top">
                    <el-button @click="selectAllViewField">全选</el-button>
                  </el-tooltip>
                  <el-button type="primary" @click="chooseViewField">保存配置</el-button>
                </span>
          </el-dialog>

          <el-dialog
              title="设置查询条件"
              top="4vh"
              custom-class="search-box"
              :visible.sync="isShowSearchConditon">
              <SearchCondition  :key="searchTime" ref="searchConditon" :conditionFields="formConditionFields"  :isShowLeftModel="false"  :isHideSearch="false" @chooseSearchConditon="chooseSearchConditon" />
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowSearchConditon = false">取 消</el-button>
                  <el-button @click="resetSearchConditon">重置</el-button>
                  <el-button type="primary" @click="chooseSearchConditon">确 定</el-button>
              </span>
          </el-dialog>
            
            <!-- 表单生成测试 -->
            <!-- <div style="max-width: 500px; width: 100%; border: 1px solid #ececec;" v-if="fields.length > 0">
                <el-button type="primary" @click="handleRefreshForm" style="width: 100%;">动态生成表单测试。点击「 刷新 」表单</el-button>
                <RenderForm v-if="isShow" :fields="fieldsList" @formSubmit="handleSubmit"/>
            </div> -->
        </div>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable'; // Draggable组件的分组配置文档 https://github.com/RubaXa/Sortable#group-option
    // import RenderForm from '@/components/RenderForm';
    import { getFormFieldListByIds } from '@/data-model';
    import SelectMultiple from '@/components/SelectMultiple';
    import FieldProps from '@/components/FieldProps';
    import SubformField from './SubformField';
    import * as formBaseField from './formBaseField';
    import { getUUID } from '@/utils/grocer';
    import { isEmpty, cloneDeep } from 'lodash';

    export default {
        components: {
            Draggable,
            // RenderForm,
            SelectMultiple,
            FieldProps,
            SubformField
        },
        data () {
            return {
                showRelateModelCf: false, // 显示关联表单配置按钮
                relateModelList: [], // 关联过当前表单的所有其他表单,示例数据[{modelId: 1, modelName: '表单A'}]
                relateModelSelected: [], // 选择的关联表单
                relateFormFieldModelSelected: [],
                relateLinkFormModelSelected: [],
                relateModelConfig: false, // 选中状态
                relateShowCardModelConfig: false,
                showCascadeMode: false,
                cascadeModeConfig: true,
                loadTimer: '',
                isShow: true, // 临时测试
                activeName: 'components', // 属性编辑区域，默认选中的tab
                selectedField: undefined, // 正在编辑的字段对象
                formToolbarOpts: {
                    group: {
                        name: 'formToolbar', // 列表分组，不同名称的分组不同互相拖动;
                        pull: 'clone', // 是否克隆列表内拖动的元素
                        put: false,
                        revertClone: true
                    },
                    sort: false // 是否支持排序
                },
                formContentOpts: {
                    // draggable: '.form-item-label',
                    // dragClass: '.sortable-drag',
                    handle: '.form-item-label',
                    group: {
                        name: 'formContent',
                        put: [ 'formToolbar' ]
                    },
                    sort: true
                },
                isPay: -1, // 企业是否为付款企业，0:未付款，1：已付款
                list1: [
                    formBaseField.getTextField(),
                    formBaseField.getNumberField(),
                    formBaseField.getDateField(),
                    formBaseField.getCalculationField(),
                    formBaseField.getCategoryField(),
                    formBaseField.getSelectField(),
                    formBaseField.getFileField(),
                    formBaseField.getAddrField(),
                    formBaseField.getCascaderField(),
                    formBaseField.getDictionaryField(),
                    formBaseField.getSerialNumberField(),
                    formBaseField.getBusinessTreeField(),
                    formBaseField.getUserField(),
                    formBaseField.getDepartmentField(),
                    formBaseField.getLinkField(),
                    formBaseField.getSubformField(),
                    formBaseField.getArchiveField(),
                    // formBaseField.getProcessField(),
                    formBaseField.getSubFormSummaryField(),
                    formBaseField.getDividerField(),
                    formBaseField.getLocationField()
                ],
                defaultFields: [
                    formBaseField.getTextField()
                ],
                subformList: [
                    formBaseField.getTextField()
                ],
                isViewSubFormBtn: false, // 显示子表单模式设置按钮
                isConfigRelateModelConfig: false,
                isConfigShowCardModelConfig: false,
                isConfigFormLeftTree: false,
                leftTreeFieldsConfigList: [], // 配置了左树右边显示的字段集合,示例数据[{fieldId: 'abc100', fieldName: '字段A'}]
                formleftTreeFieldsSelected: [], // 选择了配置左树右边的字段
                isShowFilterField: false,
                fieldTime: '',
                sourceOptions: [],
                allFields: [],
                selectViewFields: [],
                isRefreshCondition: true,
                isShowSearchConditon: false,
                formConditionFields: [],
                searchTime: '',
                isRefreshLeftTree: true,
                leftTreeOpts: {
                    handle: '.el-checkbox',
                    group: {
                        name: 'leftTree',
                        put: [ 'formToolbar' ]
                    },
                    sort: true
                },
                relateFormOpts: {
                    handle: '.el-checkbox',
                    group: {
                        name: 'relateForm',
                        put: [ 'formToolbar' ]
                    },
                    sort: true
                },
                relateShowCardModelFormField: [],
                refFormField: false
            };
        },
        watch: {
            cascadeModeConfig (val) {
                if (val) {
                    this.modelData.ext2 = '0';
                } else {
                    this.modelData.ext2 = '1';
                }
            }
        },
        props: {
            fieldsList: {
                type: Array,
                default: () => { return []; }
            },
            modelData: {
                type: Object,
                default: {
                    colSpan: 1,
                    ext1: 0,
                    ext2: '0',
                    relateModelViewIds: '',
                    relateModelRequired: false,
                    relateModelQuote: false,
                    relateModelList: []
                }
            },
            channelFlag: { // 外部传入的渠道标识，默认是客户使用，us客户，cs客服
                type: String
            },
            appId: { // 外部传入的渠道标识，所属应用（客服系统过来用）
                type: String
            }
        },
        computed: {
            fields () {
                this.isViewSubFormBtn = false;// 显示子表单模式设置按钮
                this.showCascadeMode = false;
                let cnt = 0;
                if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
                    this.fieldsList.forEach(item => {
                        item.label = formBaseField.getFieldLabel(item.type);
                        if (!item.options) {
                            item.options = {};
                            item.options.fieldList = [];
                        }
                        item.options.numVal = '';
                        item.options.numColor = '';
                        if (item.type === 'subform') {
                            this.isViewSubFormBtn = true;// 显示子表单模式设置按钮
                            item.options.fieldList.forEach(subitem => {
                                subitem.label = formBaseField.getFieldLabel(subitem.type);
                            });
                            let ext2 = item.options.ext2;
                            if (ext2) {
                                let obj = JSON.parse(ext2);
                                if (obj.isLimitNumData) {
                                    item.options.isLimitNumData = obj.isLimitNumData;
                                    item.options.limitNums = obj.limitNums;
                                }
                            }
                        }
                        if (item.type === 'link') {
                            cnt++;
                            let ext2 = item.options.ext2;
                            if (ext2) {
                                let obj = JSON.parse(ext2);
                                if (obj.limitData) {
                                    item.options.limitData = obj.limitData;
                                    if (typeof (obj.limitFieldDataArray) === 'string') {
                                        item.options.limitFieldDataArray = JSON.parse(obj.limitFieldDataArray);
                                    } else {
                                        item.options.limitFieldDataArray = obj.limitFieldDataArray;
                                    }
                                }
                            }
                        }
                        if (item.type === 'text') {
                            let ext2 = item.options.ext2;
                            if (ext2) {
                                let obj = JSON.parse(ext2);
                                if (obj.fieldMaxLength) {
                                    item.options.fieldMaxLength = obj.fieldMaxLength;
                                }
                            }
                        }
                        if (item.type === 'user') {
                            let ext2 = item.options.ext2;
                            if (ext2) {
						        let obj = JSON.parse(ext2);
						        if (obj.showUserDetails) {
						            item.options.showUserDetails = obj.showUserDetails;
						        }
                                if (obj.setDataRelation) {
                                    item.options.setDataRelation = obj.setDataRelation;
                                    if (typeof (obj.userFieldDataRelation) === 'string') {
                                        item.options.userFieldDataRelation = JSON.parse(obj.userFieldDataRelation);
                                    } else {
                                        item.options.userFieldDataRelation = obj.userFieldDataRelation;
                                    }
                                }
						    }
                        }
                        if (item.type === 'address') {
						    let ext2 = item.options.ext2;
						    if (ext2) {
						        let obj = JSON.parse(ext2);
						        if (obj.addressLevel) {
						            item.options.addressLevel = obj.addressLevel;
						        }
						    }
                        }
                        if (item.type === 'subform') {
                            let sunFieldList = item.options.fieldList;
                            for (let i = 0; i < sunFieldList.length; i++) {
                                let sonObj = sunFieldList[i];
                                if (sonObj.type === 'user') {
                                    let ext2 = sonObj.options.ext2;
                                    if (ext2) {
                                        let obj = JSON.parse(ext2);
                                        if (obj.setDataRelation) {
                                            sonObj.options.setDataRelation = obj.setDataRelation;
                                            if (typeof (obj.userFieldDataRelation) === 'string') {
                                                sonObj.options.userFieldDataRelation = JSON.parse(obj.userFieldDataRelation);
                                            } else {
                                                sonObj.options.userFieldDataRelation = obj.userFieldDataRelation;
                                            }
                                        }
                                    }
                                }
                                if (sonObj.type === 'address') {
                                    let ext2 = sonObj.options.ext2;
                                    if (ext2) {
                                        let obj = JSON.parse(ext2);
                                        if (obj.addressLevel) {
                                            sonObj.options.addressLevel = obj.addressLevel;
                                        }
                                    }
                                }
                                if (sonObj.type === 'dictionary') {
                                    let ext2 = sonObj.options.ext2;
                                    if (ext2) {
                                        let obj = JSON.parse(ext2);
                                        if (obj.dictionaryTreeChooseSonNode) {
                                            sonObj.options.dictionaryTreeChooseSonNode = obj.dictionaryTreeChooseSonNode;
                                        } else {
                                            sonObj.options.dictionaryTreeChooseSonNode = false;
                                        }
                                        if (obj.dictionaryTreeChooseParentNode) {
                                            sonObj.options.dictionaryTreeChooseParentNode = obj.dictionaryTreeChooseParentNode;
                                        } else {
                                            sonObj.options.dictionaryTreeChooseParentNode = false;
                                        }
                                    }
                                }
                            }
                        }
                        if (item.type === 'date') {
                            let ext2 = item.options.ext2;
                            if (ext2) {
                                let obj = JSON.parse(ext2);
                                if (obj.syncApproveTime) {
                                    item.options.syncApproveTime = obj.syncApproveTime;
                                }
                                if (obj.syncTaskTime) {
                                    item.options.syncTaskTime = obj.syncTaskTime;
                                }
                                if (obj.syncCreateDataTime) {
                                    item.options.syncCreateDataTime = obj.syncCreateDataTime;
                                }
                                if (obj.isDynamicAssignmentDate) {
                                    item.options.isDynamicAssignmentDate = obj.isDynamicAssignmentDate;
                                }
                                if (obj.dynamicAssignmentDateSourceFieldId) {
                                    item.options.dynamicAssignmentDateSourceFieldId = obj.dynamicAssignmentDateSourceFieldId;
                                }
                                if (obj.dynamicAssignmentDateYear) {
                                    item.options.dynamicAssignmentDateYear = obj.dynamicAssignmentDateYear;
                                }
                                if (obj.dynamicAssignmentDateMonth) {
                                    item.options.dynamicAssignmentDateMonth = obj.dynamicAssignmentDateMonth;
                                }
                                if (obj.dynamicAssignmentDateDay) {
                                    item.options.dynamicAssignmentDateDay = obj.dynamicAssignmentDateDay;
                                }
                            }
                        }
                        if (item.type === 'businessTree') {
                            let ext2 = item.options.ext2;
                            if (ext2) {
                                let obj = JSON.parse(ext2);
                                if (obj.isRelatedDepartments) {
                                    item.options.isRelatedDepartments = obj.isRelatedDepartments;
                                } else {
                                    item.options.isRelatedDepartments = false;
                                }
                                if (obj.businessTreeChooseSonNode) {
                                    item.options.businessTreeChooseSonNode = obj.businessTreeChooseSonNode;
                                } else {
                                    item.options.businessTreeChooseSonNode = false;
                                }
                                if (obj.businessTreeChooseParentNode) {
                                    item.options.businessTreeChooseParentNode = obj.businessTreeChooseParentNode;
                                } else {
                                    item.options.businessTreeChooseParentNode = false;
                                }
                            }
                        }
                        if (item.type === 'dictionary') {
                            let ext2 = item.options.ext2;
                            if (ext2) {
                                let obj = JSON.parse(ext2);
                                if (obj.dictionaryTreeChooseSonNode) {
                                    item.options.dictionaryTreeChooseSonNode = obj.dictionaryTreeChooseSonNode;
                                } else {
                                    item.options.dictionaryTreeChooseSonNode = false;
                                }
                                if (obj.dictionaryTreeChooseParentNode) {
                                    item.options.dictionaryTreeChooseParentNode = obj.dictionaryTreeChooseParentNode;
                                } else {
                                    item.options.dictionaryTreeChooseParentNode = false;
                                }
                            }
                        }
                    });
                    if (cnt > 1) {
                        this.showCascadeMode = true;
                        if (this.modelData.ext2 && this.modelData.ext2 === '1') {
                            this.cascadeModeConfig = false;
                        } else {
                            this.modelData.ext2 = '0';
                        }
                    }
                    return this.fieldsList;
                } else {
                    this.defaultFields.forEach(item => {
                        item.options.numVal = '';
                        item.options.numColor = '';
                        this.fieldsList.push(item);
                    });
                    return this.fieldsList;
                }
            },
            activeClass (uuid) {
                return (uuid) => {
                    if (this.selectedField) {
                        return {
                            selected: uuid === this.selectedField.id
                        };
                    } else {
                        return false;
                    }
                };
            }
        },
        // watch: {
        //     fieldsList () {
        //         this.isViewSubFormBtn = false;// 显示子表单模式设置按钮
        //         if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
        //             this.fieldsList.forEach(item => {
        //                 if (item.type === 'subform') {
        //                    console.log(item);
        //                     this.isViewSubFormBtn = true;// 显示子表单模式设置按钮
        //                 }
        //             });
        //         }
        //          console.log(this.isViewSubFormBtn);
        //     }
        // },
        created () {
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                this.isPay = currentUserInfo.companyInfo.isPay;
                if (currentUserInfo.companyInfo.isPay > 0) {
                    this.list1.push(formBaseField.getProcessField());
                }
            }
            // this._initPage();
        },
        methods: {
            async _initPage () {
                // console.log("==========="+this.channelFlag+"+++++"+this.appId );
                // 是否显示关联表单配置
                // console.log(this.modelData.relateModelList);
                this.showRelateModelCf = false;
                if (this.modelData.relateModelList != null && this.modelData.relateModelList.length > 0) {
                    this.showRelateModelCf = true;
                }
                if (!isEmpty(this.modelData.relateModelViewIds)) {
                    this.relateModelSelected = this.modelData.relateModelViewIds.split(',');
                    this.relateModelConfig = true;
                }
                if (!isEmpty(this.modelData.formLeftTreeFields)) {
                    this.formleftTreeFieldsSelected = this.modelData.formLeftTreeFields.split(',');
                }
            },
            _itemChangeAdd (obj) {
                if (obj.element.type === 'date' || obj.element.type === 'user' || obj.element.type === 'subform') { // 子表单的options.defaultValue用于显示复选框，日期和用户默认当前值
                    if (obj.element.options.defaultValue === 'true' || obj.element.options.defaultValue === true) {
                        obj.element.options.defaultValue = true;
                    } else {
                        obj.element.options.defaultValue = false;
                    }
                }
                // 克隆新增的字段，保证每个对象的独立性
                let objClone = JSON.parse(JSON.stringify(obj.element));
                const uuid = getUUID(16, 16);
                objClone.id = uuid;
                // objClone.uuid = uuid;
                objClone.formField = `${objClone.type}_${uuid}`;
                this.fieldsList.splice(obj.newIndex, 1, objClone);
            },
            handleFormChange (changeObj) {
                if (changeObj && changeObj.added) {
                    this._itemChangeAdd(changeObj.added);
                }
            },
            handleRelateFormChange () {
                let orderFieldsSelected = cloneDeep(this.relateModelSelected);
                this.relateModelSelected = [];
                this.modelData.relateModelList.forEach(item => {
                    orderFieldsSelected.forEach(selectedItem => {
                        if (selectedItem === item.id) {
                            this.relateModelSelected.push(selectedItem);
                        }
                    });
                });
                this.handleRelateModelCheckedChange();
            },
            isCanDelete (obj) {
                let e = obj.options.ext2;
                if (e && e !== '') {
                    let opt = JSON.parse(e);
                    if (opt.defaultUserField && opt.defaultUserField == 1) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            },
            renderValue (field) {
                this.selectedField = cloneDeep(field);
                let fieldArray = [];
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let cur = this.fieldsList[i];
                    if (cur.id === this.selectedField.id) {
                        fieldArray.push(this.selectedField);
                        cur = cloneDeep(field);
                    } else {
                        fieldArray.push(cur);
                    }
                }
                this.fieldsList = cloneDeep(fieldArray);
                this.modelData.fieldsList = this.fieldsList;
            },
            renderFieldList (fieldsList) {
                this.modelData.fieldsList = this.fieldsList;
            },
            handleSelectItem (item) {
                let e = item.options.ext2;
                if (e && e !== '') { // 默认字段不允许修改
                    let opt = JSON.parse(e);
                    if (opt.defaultUserField && opt.defaultUserField == 1) {
                        this.$message({
                            message: '默认字段不允许修改',
                            type: 'warning'
                        });
                        return false;
                    }
                }
                if (item.type === 'date' || item.type === 'user' || item.type === 'subform') { // 子表单的options.defaultValue用于显示复选框，日期和用户默认当前值
                    if (item.options.defaultValue === 'true' || item.options.defaultValue === true) {
                        item.options.defaultValue = true;
                    } else {
                        item.options.defaultValue = false;
                    }
                    let ext = item.options.ext2;
                    if (ext) {
                        let obj = JSON.parse(ext);
                        if (obj.showUserDetails === true || obj.showUserDetails === 'true') {
                            item.options['showUserDetails'] = true;
                        } else {
                            item.options['showUserDetails'] = false;
                        }
                    }
                }
                if (item.type === 'number' || item.type === 'calculation') {
                    let ext2 = item.options.ext2;
                    if (ext2) {
                        let ext = JSON.parse(ext2);
                        let numVal = ext.numVal;
                        let numColor = ext.numColor;
                        item.options['numVal'] = numVal;
                        item.options['numColor'] = numColor;
                    }
                }
                if (item.type === 'address') {
                    let ext = item.options.ext2;
                    if (ext) {
					    let obj = JSON.parse(ext);
					    if (obj.addressLevel) {
					        item.options['addressLevel'] = obj.addressLevel;
					    }
                    }
                }
    
                this.loadTimer = new Date().getTime();
                this.selectedField = item;
                this.activeName = 'props';
            },
            handleSubformItemSelect (json) {
                this.handleSelectItem(json.field);
            },
            handleSubmit (formData) {
                // console.log(JSON.stringify(formData, null, 2));
            },
            handleDeleteItem (index) {
                if (this.fieldsList[index].id && this.fieldsList[index].id.length === 32) {
                    this.$confirm('该字段是原表字段，删除后将无法恢复，您确定要删除字段【' + this.fieldsList[index].label + '】吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        this.fieldsList.splice(index, 1);
                    }).catch(() => {});
                } else {
                    this.fieldsList.splice(index, 1);
                }
            },
            handleRefreshForm () {
                // console.log('刷新表单');
                this.isShow = false;
                this.$nextTick(() => {
                    this.isShow = true;
                });
            },
            activeStyle (element) {
                let single = {
                    'width': '60%',
                    'margin': '10px 20px 2px 10px',
                    'float': 'left'
                };
                // if (element.type === 'subform' || element.options.unique) {
                if (element.type === 'subform' || (element.hasOwnProperty('options') && element.options.unique)) {
                    single.width = '100%';
                    single.height = 'auto';
                    return single;
                } else {
                    if (this.modelData.colSpan === 2) { // 一行两列
                        single.width = '40%';
                    } else if (this.modelData.colSpan === 3) { // 一行三列
                        single.width = '28%';
                    }
                    // else if (this.modelData.colSpan === 4) { // 一行四列
                    //     single.width = '20%';
                    // }
                }
                return single;
            },
            handleRelateModelCheckedChange () {
                // console.log(this.relateModelSelected);
                let relateModelSelected = this.relateModelSelected.join(',');
                this.$emit('refreshModelViewIds', relateModelSelected);
            },
            handleConfigShowCardModelData () {
                let dataShowConfig = {};
                dataShowConfig.relateShowCardModelConfig = this.relateShowCardModelConfig;
                let relateFormFieldModelSelectedIds = this.relateFormFieldModelSelected.join(',');
                let cacheRelateFormFieldModelSelected = [];
                for (let i = 0; i < this.relateShowCardModelFormField.length; i++) {
                    let curItem = this.relateShowCardModelFormField[i];
                    if (relateFormFieldModelSelectedIds.indexOf(curItem.id) !== -1) {
                        cacheRelateFormFieldModelSelected.push(curItem);
                    }
                }
                dataShowConfig.relateFormFieldModelSelected = cacheRelateFormFieldModelSelected;
                let relateLinkFormModelSelectedIds = this.relateLinkFormModelSelected.join(',');
                let cacheRelateLinkFormModelSelected = [];
                for (let i = 0; i < this.modelData.relateModelList.length; i++) {
                    let curItem = this.modelData.relateModelList[i];
                    if (relateLinkFormModelSelectedIds.indexOf(curItem.id) !== -1) {
                        cacheRelateLinkFormModelSelected.push(curItem);
                    }
                }
                dataShowConfig.relateLinkFormModelSelected = cacheRelateLinkFormModelSelected;
                this.$emit('refreshDataShowConfig', dataShowConfig);
            },
            configRelateModelConfig () {
                this.isConfigRelateModelConfig = true;
            },
            configShowCardModelConfig () {
                if (this.modelData.dataShowConfig) {
                    this.relateShowCardModelConfig = this.modelData.dataShowConfig.relateShowCardModelConfig;
                    if (this.relateShowCardModelConfig) {
                        this.refFormField = true;
                        this.changeRelateShowCardModelConfig();
                    }
                    if (this.modelData.dataShowConfig.relateLinkFormModelSelected && this.modelData.dataShowConfig.relateLinkFormModelSelected.length > 0) {
                        this.relateLinkFormModelSelected = [];
                        for (let i = 0; i < this.modelData.dataShowConfig.relateLinkFormModelSelected.length; i++) {
                            let cur = this.modelData.dataShowConfig.relateLinkFormModelSelected[i];
                            this.relateLinkFormModelSelected.push(cur.id);
                        }
                    }
                    if (this.modelData.dataShowConfig.relateFormFieldModelSelected && this.modelData.dataShowConfig.relateFormFieldModelSelected.length > 0) {
                        this.relateFormFieldModelSelected = [];
                        for (let i = 0; i < this.modelData.dataShowConfig.relateFormFieldModelSelected.length; i++) {
                            let cur = this.modelData.dataShowConfig.relateFormFieldModelSelected[i];
                            this.relateFormFieldModelSelected.push(cur.id);
                        }
                    }
                }
                this.isConfigShowCardModelConfig = true;
            },
            handleFormLeftTreeCheckedChange () {
                // console.log(this.relateModelSelected);
                let formleftTreeFieldsSelected = this.formleftTreeFieldsSelected.join(',');
                this.$emit('refreshFormLeftTreeFields', formleftTreeFieldsSelected);
            },
            configFormLeftTree () {
                this.leftTreeFieldsConfigList = [];
                this.isConfigFormLeftTree = false;
                this.resetFormLeftTree();
                this.isConfigFormLeftTree = true;
            },
            resetFormLeftTree () {
                if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
                    this.fieldsList.forEach(item => {
                        if ((item.type === 'category' && item.options.config.type === 'single') ||
                    item.type === 'select' ||
                      item.type === 'link' ||
                      item.type === 'department' ||
                      item.type === 'dictionary' ||
                      item.type === 'businessTree') {
                            this.leftTreeFieldsConfigList.push(item);
                        }
                    });
                }
            },
            // handleFilterField() {
            //     if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
            //         this.isShowFilterField = true;
            //         this.modelData.selectedFields = '';
            //         this.sourceOptions = [];
            //         let tableColumnsView = cloneDeep(this.fieldsList);
            //         tableColumnsView.forEach((field) => {
            //             if (field.type !== 'divider' && field.id !== 'approvalStatus' && field.id !== 'approvalResultDetail' && field.id !== 'num' && field.id !== 'processInstanceName') {
            //                 field.label = field.name;
            //                 this.sourceOptions.push(field);
            //             }
            //         });
            //         this.sourceOptions.unshift({ id: 'ALL_SELECT', label: 'ALL' });
            //         this.sourceOptions.push({ id: 'appCreatedByName', label: '应用录入人' });
            //         this.sourceOptions.push({ id: 'appCreatedByDate', label: '应用录入时间' });
            //         setTimeout(() => { // 调用子组件的方法
            //             this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
            //         }, 100);
            //     }
            // },
            handleFilterField () {
                this.isShowFilterField = true;
                if (Array.isArray(this.fieldsList) && this.fieldsList.length > 0) {
                    let fieldsMap = new Map();
                    this.sourceOptions = [];
                    this.selectViewFields = [];
                    this.allFields = [];
                    let tableColumnsView = cloneDeep(this.fieldsList);
                    tableColumnsView.forEach((field) => {
                        if (field.id !== 'approvalStatus' && field.id !== 'approvalResultDetail' && field.id !== 'num' && field.id !== 'processInstanceName') {
                            this.sourceOptions.push(field);
                            this.selectViewFields.push(field.id);
                            fieldsMap.set(field.id, field);
                        }
                    });
                    for (let i = 0; i < this.fieldsList.length; i++) {
                        this.fieldsList[i].label = this.fieldsList[i].name;
                        this.allFields.push(this.fieldsList[i]);
                    }
                    // this.sourceOptions.unshift({ id: 'ALL_SELECT', label: 'ALL' });
                    this.allFields.unshift({ id: 'ALL_SELECT', label: 'ALL(全部选择)' });
                    setTimeout(() => { // 调用子组件的方法
                        this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                    }, 100);
                }
            },
            async chooseViewField () {
                this.isShowFilterField = false;
                this.fieldTime = new Date().getTime();
                let selectedFields = this.$refs.selectMultiple.getSelectFields();
                this.modelData.selectedFields = selectedFields;
            },
            async clearViewField () { // 清空
                this.sourceOptions = [];
                this.selectViewFields = [];
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectMultiple.initFields();// 每次切换model时清空显示字段
                }, 100);
            },
            async selectAllViewField () { // 全选
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.selectMultiple.selectAll('ALL_SELECT');
                }, 100);
            },
            async handleFilterCondition () {
                this.isShowSearchConditon = false;
                this.formConditionFields = [];
                if (this.modelData && this.modelData.formConditionFields) {
                    try {
                        let conditionFields = JSON.parse(this.modelData.formConditionFields);
                        this.formConditionFields = conditionFields;
                    } catch (e) {
                        if (this.isRefreshCondition) {
                            await this.resetSearchConditon();
                            this.isRefreshCondition = false;
                        }
                    }
                } else {
                    if (this.isRefreshCondition) {
                        await this.resetSearchConditon();
                        this.isRefreshCondition = false;
                    }
                }
                this.isShowSearchConditon = true;
            },
            isJson (obj) { // 判断obj是否为json对象
                var isjson = typeof (obj) === 'object' && Object.prototype.toString.call(obj).toLowerCase() == '[object object]' && !obj.length;
                return isjson;
            },
            async resetSearchConditon () {
                this.formConditionFields.length = 0;
                let columns = cloneDeep(this.fieldsList);
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                this.formConditionFields = await getFormFieldListByIds(idArr.join(','));
                this.searchTime = new Date().getTime();
            },
            async chooseSearchConditon () {
                this.isShowSearchConditon = false;
                let searchCondition = this.$refs.searchConditon.getSearchCondition();
                this.modelData.formConditionFields = JSON.stringify(searchCondition);
            },
            handleDragLeftTree () {
                let orderFieldsSelected = cloneDeep(this.formleftTreeFieldsSelected);
                this.formleftTreeFieldsSelected = [];
                this.leftTreeFieldsConfigList.forEach(item => {
                    orderFieldsSelected.forEach(selectedItem => {
                        if (selectedItem === item.id) {
                            this.formleftTreeFieldsSelected.push(selectedItem);
                        }
                    });
                });
                this.handleFormLeftTreeCheckedChange();
            },
            renderModelData (obj) {
                for (let i = 0; i < this.modelData.fieldsList.length; i++) {
                    let cur = this.modelData.fieldsList[i];
                    if (cur.id === obj.id) {
                        if (obj.options.ext2) {
                            let extObj = JSON.parse(obj.options.ext2);
                            extObj.setDataRelation = obj.options.setDataRelation;
                            if (extObj.setDataRelation) {
                                extObj.userFieldDataRelation = obj.options.userFieldDataRelation;
                            } else {
                                delete extObj.userFieldDataRelation;
                            }
                            obj.options.ext2 = JSON.stringify(extObj);
                        }
                        this.modelData.fieldsList[i] = obj;
                        this.selectedField = obj;
                    }
                }
            },
            changeSelectTableHeaderFields (obj) {
                for (let i = 0; i < this.modelData.fieldsList.length; i++) {
                    let cur = this.modelData.fieldsList[i];
                    if (cur.id === obj.id) {
                        // field.options.config.form.selectTableHeaderFieldsArray
                        // if (obj.options.ext2) {
                        //     let extObj = JSON.parse(obj.options.ext2);
                        //     extObj.setDataRelation = obj.options.setDataRelation;
                        //     if (extObj.setDataRelation) {
                        //         extObj.userFieldDataRelation = obj.options.userFieldDataRelation;
                        //     } else {
                        //         delete extObj.userFieldDataRelation;
                        //     }
                        //     obj.options.ext2 = JSON.stringify(extObj);
                        // }
                        this.modelData.fieldsList[i] = obj;
                        // this.selectedField = obj;
                    }
                }
            },
            changeRelateShowCardModelConfig () {
                if (this.relateShowCardModelConfig) { // 启用了配置
                    // 1.展现当前关联数据
                    for (let i = 0; i < this.fieldsList.length; i++) {
                        let cur = this.fieldsList[i];
                        if (cur.type === 'link') {
                            this.relateShowCardModelFormField.push(cur);
                        }
                    }
                    this.refFormField = true;
                } else {
                    let dataShowConfig = {};
                    dataShowConfig.relateShowCardModelConfig = false;
                    this.relateShowCardModelFormField = [];
                    this.relateFormFieldModelSelected = [];
                    this.relateLinkFormModelSelected = [];
                    this.$emit('refreshDataShowConfig', dataShowConfig);
                    this.refFormField = false;
                }
            }
        }
    };
</script>

<style lang="less">
    @import url('./custom-form');
    .custom-form {
        flex: 1;
        border-top: 1px solid #ececec;
        display: flex;

        .form-toolbar {
            width: 235px;
            border-right: 1px solid #ececec;
            overflow-y: auto;
            display: flex;
            justify-content: center;
            position: absolute;
            z-index: 1;
            height: 100%;
            // min-height: 30vw;
            .el-tabs__header{
              padding: 0;
              position: relative;
              margin: 0 0 5px;
            }
        }

        .form-content {
            flex: 1;
            padding: 20px 15px;
            overflow: auto;
            min-height: 24vw;
            @media screen and (min-width: 1024px) and (max-width: 1366px) {
                min-height: 22vw;
            }
            // max-height:500px;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            align-items: center;
            // overflow-y: auto;
            position: relative;
            padding-left: 235px;
            .modelIntroduce {
                width: calc(~'100% - 120px');
                margin-left: 29px;
                // position:absolute;
                // // border:1px solid red;
                // left:5px;
                // top:5px;
            }
            .checkBox-style {
                margin-left:30px;
            }
            .relateModel {
                width: 100%;
                margin-left: 40px;
                margin-top: 2%;
                max-width: 95%;
                height: 100%;
            }
        }
        .el-tabs {
            flex: 1;
            margin: 0 5px;
        }
        .field-list {
            width: 100%;
            margin-left: 30px;
            margin-top: 10px;
            // max-width: 800px;
            max-width: 95%;
            height: auto;
            min-height: 90%;
            // @media screen and (min-width: 1024px) and (max-width: 1366px) {
            //    height: 80%;
            // }
            // max-height: -webkit-fill-available;
            span {
                display: block;
                height: 100%;
                label{
                    span{
                       display: inline;
                    }
                }
                .form-item-value{
                    flex: 1;
                }
                .form-item-option{
                    align-items: center;
                }
            }
        }
        .form-required {
            color: red;
        }
        .form-item-label {
            cursor: move;
            display: flex;
            // justify-content: center;
            align-items: center;
        }

        // .form-item{
        //     float:left;
        //     width:40%;
        //     margin:10px 20px 2px 10px;
        // }
    }
</style>



// WEBPACK FOOTER //
// src/components/CustomForm/CustomForm.vue